import { Controller, useFormContext } from 'react-hook-form';
import { Grid, Radio, FormControlLabel, FormControl, FormLabel, RadioGroup, FormHelperText } from '@mui/material';
import { Input } from '@shared';

const SECURITY_QUESTION_RADIOS = [
  { label: 'In what city or town was your first job?', value: 'First Job' },
  { label: 'What street did you grow up on?', value: 'Street' },
  { label: 'What is the name of your first school?', value: 'First School' },
];

export const StepSecurityQuestions = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container>
      <Grid item xs={12}>
        <FormControl component='fieldset' error={!!errors.securityQuestion}>
          <FormLabel component='legend'>
            Please choose one question from the list below. Security question will be used in order to verify your identity when you contact us by
            phone. *
          </FormLabel>
          <RadioGroup aria-label='position' row>
            {SECURITY_QUESTION_RADIOS.map((radio, idx) => (
              <FormControlLabel
                key={idx}
                label={radio.label}
                labelPlacement='end'
                control={
                  <Controller
                    name='securityQuestion'
                    control={control}
                    rules={{ required: 'Security Question is required' }}
                    render={({ field }) => <Radio {...field} color='primary' value={radio.value} checked={radio.value === field.value} />}
                  />
                }
              />
            ))}
          </RadioGroup>
          {errors?.securityQuestion?.message && <FormHelperText error>{errors.securityQuestion.message as string}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Controller
          name='securityAnswer'
          control={control}
          rules={{ required: 'Answer is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Answer' margin='normal' required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
    </Grid>
  );
};
